export const ContrastColor = "#da4ea2";
